import React, { ReactNode } from 'react';
import './coursePageBody.module.scss';

type Props = {
  children: ReactNode;
  'data-value'?: string;
};

export const CoursePageBody = ({ children, 'data-value': dataAttribute }: Props) => {
  return (
    <div styleName="body" data-value={dataAttribute}>
      <div styleName="body-inner">{children}</div>
    </div>
  );
};
